import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import styles from "./Manual.module.scss";

const id = "dNT6";
const idNext = "dNT7";
const idPrev = "dNT5";

const next = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: AllLottery
          - choice: AllSports
          - choice: Lotto
          - choice: Vikinglotto
          - choice: Eurojackpot
          - choice: Extra
          - choice: Joker
          - choice: Keno
          - choice: Nabolaget
          - choice: Tipping
          - choice: Oddsbomben
      - parameter: Pause_Options
        choices:
          - choice: SpillePause
          - choice: Utestegning
      - output parameter: reminder_lotto
        default value: på
    logic:
      - assignment: Set reminder - LOTTO
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Lotto']  =>
          'reminder_lotto' = 'av'"
`;

const prev = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: AllLottery
          - choice: AllSports
          - choice: Lotto
          - choice: Vikinglotto
          - choice: Eurojackpot
          - choice: Extra
          - choice: Joker
          - choice: Keno
          - choice: Nabolaget
          - choice: Tipping
          - choice: Oddsbomben
      - parameter: Pause_Options
        choices:
          - choice: SpillePause
          - choice: Utestegning
`;

function ManualDedicatedNorskTipping6({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_logic") && !document.getElementById("logic_assignment") && (
        <div className={`${styles["container"]} ${styles["container-dnt6a"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-gp1a" className={`${styles["container__text"]}`}>
            <p>To show/hide logic click on the header.</p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-gp1a"
            end="header_logic"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      {document.getElementById("logic_assignment") && (
        <div className={`${styles["container"]} ${styles["container-dnt6b"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-gp1b"
            className={`${styles["container__text"]} ${styles["container__text"]}`}>
            <p>Click here to add an assignment</p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-gp1b"
            end="logic_assignment"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-dnt6"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Model logic is a set of constraints that define allowed combinations of input
              parameters and a set of assignments to define values of output parameters. In this
              scenario, we have to refine conditions for <b>reminder_lotto</b> - In what cases
              should it turn to 'av'.
            </p>
            <p>
              To access logic of a function, click on the <b>FUNCTION LOGIC</b> tab, which is
              located at the bottom of the screen.
            </p>
            <p>
              To create an assignment, select the <b>Assignments</b> section. A button named{" "}
              <b>ADD ASSIGNMENT</b> should appear. Type its name, which should be{" "}
              <b>Set reminder - LOTTO</b>. Afterwards, type the expression, namely:{" "}
              <b>
                'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Lotto'] =&gt; 'reminder_lotto' =
                'av'
              </b>
              .
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping6 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun)
      return false;
    }

    let { res, msg } = tutorialUtils.validateCondition(
      root,
      "root→[function]→Demo→[logic]→Set reminder - LOTTO",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Lotto']  => 'reminder_lotto' = 'av'",
    );

    if (!res) {
      setMessage(msg)
      return false;
    }

    setTutorial(idNext);

    setMessage("")
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping6;
